import { render, staticRenderFns } from "./BundleSummary.vue?vue&type=template&id=81cf8ec6"
import script from "./BundleSummary.vue?vue&type=script&lang=js"
export * from "./BundleSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports